import { save } from "./common";
import salesApi from "./sales";

const endpoint = "/gds/offices";

export const findGdsOffices = () => salesApi.get(endpoint);

export const deleteGdsOffice = (gdsId) =>
  salesApi.delete(`${endpoint}/${gdsId}`);

export const saveGdsOffice = save(salesApi)(endpoint);
